module.exports = __webpack_public_path__ + "img/xmgl@3x.f4b2ae8d.png";